import * as swcHelpers from '@swc/helpers';
import { BundleLineItemProductType } from '../../../__generated__/sharedTypes.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getLocalizedAttribute } from '../../../utils/get-line-item-localized-attribute.js';
import { getLineItemName } from '../../../utils/get-line-item-name.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import { getSharedProps } from '../../../utils/shared-line-item-data-mapper.js';
import { getLegacyProductByType } from './utils/contact-lenses-subscription/get-legacy-product-by-type.js';
import { getSolutionProperties } from './utils/contact-lenses-subscription/get-solution-properties.js';
import { getContactLensSpecifications } from './utils/contact-lenses-subscription/get-contact-lens-specifications.js';

const mapContactLensesBundleBeneluxLineItem = (lineItemRaw, settings, intl)=>{
    const contactLensesProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.LENS);
    const solutionsProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.SOLUTION);
    const mainBundleProduct = getLegacyProductByType(lineItemRaw.bundleLineItems);
    if (!contactLensesProduct || !mainBundleProduct) {
        console.error('This bundle does not contain Contact Lenses or a mainBundleProduct');
        return null;
    }
    const contactLensVariant = contactLensesProduct.masterData.current.variant;
    const mainProductVariant = mainBundleProduct.masterData.current.variant;
    const shared = getSharedProps(lineItemRaw, mainBundleProduct, intl);
    const slug = getAttribute(mainProductVariant, 'parentSlug');
    const typeDetails = lineItemRaw.typeDetails;
    const { leftLens , rightLens  } = typeDetails.prescription;
    const solutionProperties = solutionsProduct ? getSolutionProperties(solutionsProduct, intl, settings) : null;
    return swcHelpers.objectSpread({}, shared, {
        type: 'contact-lenses-bundle-benelux',
        sku: lineItemRaw.sku,
        imageSku: getAttribute(mainProductVariant, 'imageSku'),
        productSlug: slug,
        productId: contactLensesProduct.id,
        productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, intl.locale),
        brand: {
            name: getAttribute(contactLensVariant, 'brand'),
            model: getAttribute(contactLensVariant, 'brandModel'),
            modelCode: getAttribute(contactLensVariant, 'brandModelCode')
        },
        imageUrl: settings.isBynderImagesEnabled ? getLineItemImageUrl(mainProductVariant, settings.staticsUrl, true) : getLineItemImageUrl(contactLensVariant, settings.staticsUrl),
        lensType: getLocalizedAttribute(mainProductVariant, 'lensType', intl.locale) || '',
        leftEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: getContactLensSpecifications(leftLens)
        },
        rightEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: getContactLensSpecifications(rightLens)
        }
    }, solutionProperties);
};

export { mapContactLensesBundleBeneluxLineItem };
//# sourceMappingURL=contact-lenses-bundle-benelux.js.map
